import { render, staticRenderFns } from "./ConfettiAnimation.vue?vue&type=template&id=15b4fe2c&scoped=true&"
import script from "./ConfettiAnimation.vue?vue&type=script&lang=js&"
export * from "./ConfettiAnimation.vue?vue&type=script&lang=js&"
import style0 from "./ConfettiAnimation.vue?vue&type=style&index=0&id=15b4fe2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b4fe2c",
  null
  
)

export default component.exports